import { render, staticRenderFns } from "./resources-card.vue?vue&type=template&id=9edb801c"
import script from "./resources-card.vue?vue&type=script&lang=js"
export * from "./resources-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports